import { ChevronRight } from 'lucide-react'
import { LocalizedLink } from '~/components/common/localized-link'

interface BreadcrumbItem {
  label: string
  href?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center gap-1.5 text-sm text-default-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          return (
            <li key={index} className="flex items-center gap-1.5">
              {index > 0 && <ChevronRight className="w-3.5 h-3.5 text-default-400 flex-shrink-0" />}
              {isLast || !item.href ? (
                <span className={isLast ? 'text-foreground font-medium truncate max-w-[200px]' : ''}>
                  {item.label}
                </span>
              ) : (
                <LocalizedLink
                  to={item.href}
                  className="hover:text-primary transition-colors"
                >
                  {item.label}
                </LocalizedLink>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
